import { render, staticRenderFns } from "./PiscinappSwitch.vue?vue&type=template&id=224ae77f&"
import script from "./PiscinappSwitch.vue?vue&type=script&lang=js&"
export * from "./PiscinappSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PiscinappSwitch.vue?vue&type=style&index=0&id=224ae77f&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224ae77f')) {
      api.createRecord('224ae77f', component.options)
    } else {
      api.reload('224ae77f', component.options)
    }
    module.hot.accept("./PiscinappSwitch.vue?vue&type=template&id=224ae77f&", function () {
      api.rerender('224ae77f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/piscinappSwitch/PiscinappSwitch.vue"
export default component.exports